import { useEffect, useState } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { useFlag } from '@unleash/proxy-client-react'
import { FF_ENABLE_FORETHOUGHT_CONTEXT_VARIABLES } from 'src/constants/feature-flags'
import { getForethoughtToken } from '../sduiService'

export const useGetForethoughtToken = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)
  const [token, setToken] = useState('')
  const { isAuthenticated } = useAuth0()
  const isForethoughtContextVariablesEnabled = useFlag(
    FF_ENABLE_FORETHOUGHT_CONTEXT_VARIABLES
  )

  useEffect(() => {
    if (!isAuthenticated || !isForethoughtContextVariablesEnabled) {
      return
    }

    async function getAndSetToken() {
      try {
        const token = await getForethoughtToken()
        setToken(token)
      } catch (error) {
        setError(error as Error)
      } finally {
        setIsLoading(false)
      }
    }

    getAndSetToken()
  }, [isAuthenticated, isForethoughtContextVariablesEnabled])

  return {
    isLoading,
    token,
    error
  }
}
